import request from '@/utils/request'

export function login(data) {
    return request({
        url: '/user/login',
        method: 'post',
        data
    })
}
export function rank(data) {
    return request({
        url: '/user/rank',
        method: 'get',
        params: data
    })
}

export function getTasks(data) {
    return request({
        url: '/task/getTasks',
        method: 'get',
        params: data
    })
}

export function checkTask(data) {
    return request({
        url: '/task/checkTask',
        method: 'post',
        data
    })
}


export function upload(data) {
    return request({
        url: '/upload',
        method: 'post',
        params: data,
        headers: {
            'Content-Type': 'multipart/form-data' // 设置multipart/form-data
        }
    })
}

export function saveWechatMomentsTask(data) {
    return request({
        url: '/task/saveWechatMomentsTask',
        method: 'post',
        data
    })
}

export function getWechatMomentsTask(data) {
    return request({
        url: '/task/getWechatMomentsTask',
        method: 'get',
        params: data
    })
}




export function gaizhang(data) {
    return request({
        url: '/task/gaizhang',
        method: 'post',
        data
    })
}
